import { render, staticRenderFns } from "./SubmissionFormSubmitDialog.vue?vue&type=template&id=2e9b0154&scoped=true&"
import script from "./SubmissionFormSubmitDialog.vue?vue&type=script&lang=ts&"
export * from "./SubmissionFormSubmitDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e9b0154",
  null
  
)

export default component.exports